export const PurchaseOrdersDetailsActions = {
  RetrievePurchaseOrderDetails: 'retrievePurchaseOrderDetails',
  ResetCurrentPurchaseOrderDetails: 'resetPurchaseOrderDetails',
  ManualIssueDeplete: 'manualIssueDeplete',
  SaveNewLineItem: 'saveNewLineItem',
  SavePurchaseOrder: 'savePurchaseOrder',
  RetrievePurchaseOrderHistories: 'retrievePoHistory',
  RetrievePurchaseOrderFullAuditTrial: 'retrievePurchaseOrderFullAuditTrial',
  FilterAuditTrial: 'filterAuditTrial',
  RetrievePurchaseOrderAssignemnts: 'retrievePoAssignments',
  RetrievePurchaseOrderPreviousAssignemnts: 'retrievePoPreviousAssignments',
  UpdatePurchaseOrderAssignmentsSortOrder: 'updatePoOrderSortOrder',
  UpdatePurchaseOrderPreviousAssignmentsSortOrder: 'updatePurchaseOrderPreviousAssignmentsSortOrder'
};

export const PurchaseOrdersDetailsGetters = {
  CurrentPurchaseOrder: 'getCurrentPurchaseOrder',
  GetStatuses: 'getPurchaseOrdersStatus',
  GetPoItems: 'getPoItemDetails',
  IsItemLoaded: 'getIsItemLoaded',
  PurchaseOrderHistories: 'getPurchaseOrderHistories',
  SelectedHistoryRecord: 'getPoOrderSelectedHistory',
  PurchaseOrderFullAuditTrial: 'getPurchaseOrderFullAuditTrial',
  PurchaseOrderAssignments: 'getPoOrderAssignments',
  PurchaseOrderPreviousAssignments: 'getPoOrderPreviousAssignments',
  PurchaseOrderAssignmentsSortOrder: 'getPurchaseOrderAssignmentsSortOrder',
  PurchaseOrderPreviousAssignmentsSortOrder: 'getPurchaseOrderPreviousAssignmentsSortOrder',
  IsLoading: 'isPurchaseOrderDetailsLoading'
};

export const PurchaseOrdersDetailsMutations = {
  ResetPurchaseOrder: 'resetPurchaseOrder',
  SetLoading: 'updateLoading',
  SerPurchaseOrderDetails: 'updatePurchaseOrderDetails',
  SetPoItemDetails: 'updatePoItemDetails',
  SetPurchaseOrderHistories: 'setPOHistories',
  SetPurchaseOrderFullAuditTrial: 'setPurchaseOrderFullAuditTrial',
  SetFilterAuditTrial: 'setFilterAuditTrial',
  SetPurchaseOrderAssignments: 'setPurchaseOrderAssignments',
  SetPurchaseOrderPreviousAssignments: 'setPurchaseOrderPreviousAssignments',
  SetPoOrdersAssignmentSortOrder: 'setPurchaseOrderAssignmentsSortOrder',
  SetPoOrdersPreviousAssignmentSortOrder: 'setPoOrdersPreviousAssignmentSortOrder'
};
